export const mdxStyles = {
  h1: {
    mt: "2rem",
    mb: ".25rem",
    lineHeight: 1.2,
    fontWeight: "bold",
    fontSize: "1.875rem",
    letterSpacing: "-.025em",
    color: "text",
  },
  h2: {
    mt: "2rem",
    mb: "0.5rem",
    lineHeight: 1.3,
    fontWeight: "semibold",
    fontSize: "1.5rem",
    letterSpacing: "-.025em",
    "& + h3": {
      mt: "1.5rem",
    },
    color: "text",
  },
  h3: {
    mt: "2rem",
    mb: "0.5rem",
    lineHeight: 1.25,
    fontWeight: "semibold",
    fontSize: "1.25rem",
    letterSpacing: "-.025em",
    color: "text",
  },
  h4: {
    mt: "2rem",
    lineHeight: 1.375,
    fontWeight: "semibold",
    fontSize: "1.125rem",
    color: "text",
  },
  a: {
    color: "blue.500",
    fontWeight: "semibold",
    transition: "color 0.15s",
    transitionTimingFunction: "ease-out",
    cursor: "pointer",
    _hover: {
      color: "blue.600",
      textDecoration: "underline",
    },
  },
  p: {
    lineHeight: 1.65,
    "blockquote &": {
      mt: 0,
      "& + p": {
        pt: 3,
      },
    },
    "&:not(:first-of-type)": {
      pt: 3,
    },
    color: "text",
  },
  hr: {
    my: "4rem",
    color: "text",
  },
  blockquote: {
    bg: "blue.100",
    borderWidth: "1px",
    borderColor: "blue.200",
    rounded: "lg",
    px: "1.25rem",
    py: "1rem",
    my: "1.5rem",
    color: "text",
  },
  ul: {
    mt: "1.5rem",
    ml: "1.25rem",
    "blockquote &": { mt: 0 },
    "& > * + *": {
      mt: "0.25rem",
    },
    pl: { base: "4" },
    color: "text",
  },
  code: {
    rounded: "sm",
    px: "1",
    fontSize: "0.875em",
    py: "2px",
    whiteSpace: "nowrap",
    lineHeight: "normal",
    color: "text",
  },
};
